import { useEffect } from "react";
import { useFormState } from "react-hook-form";

/**
 * ¿Hay cambios sin guardar en el formulario de la ficha? (auditoría 30/10/2026: la ventana se
 * cerraba con Esc o con un clic fuera y se perdía lo escrito sin avisar). Lo apunta el
 * formulario y lo mira la ventana antes de cerrarse.
 */
let conCambios = false;

export const hayCambiosSinGuardar = () => conCambios;
export const olvidarCambiosSinGuardar = () => {
  conCambios = false;
};

const avisarAlSalir = (e: BeforeUnloadEvent) => {
  if (!conCambios) return;
  e.preventDefault();
};

/** Dentro del <Form> de la ficha: apunta si hay cambios y avisa también al recargar la página. */
export const VigilaCambios = () => {
  const { isDirty } = useFormState();
  useEffect(() => {
    conCambios = isDirty;
    if (isDirty) window.addEventListener("beforeunload", avisarAlSalir);
    return () => {
      window.removeEventListener("beforeunload", avisarAlSalir);
      conCambios = false;
    };
  }, [isDirty]);
  return null;
};
